module.exports = __webpack_public_path__ + "media/src/assets/img/icons/jpg-af5b421a864fd53988f2e23b61b7bb84.png";